import React from 'react';
import Avatar from './avatar';
import Date from './date';
import CoverImage from './cover-image';
import Categories from './categories';

import { IAuthor } from '../models/author';
import { H2, Muted } from './text';
import { IFeaturedImage } from '../models/featured-image';
import { ICategory } from '../models/category';

export interface IProps {
	title: string;
	coverImage?: IFeaturedImage;
	date: string;
	author?: IAuthor;
	categories?: ICategory;
}

export default function PostHeader({
	title,
	coverImage,
	date,
	author,
	categories,
}: IProps) {
	return (
		<>
			{coverImage && (
				<div className="mb-8 md:mb-12 sm:mx-0">
					<CoverImage title={title} coverImage={coverImage} />
				</div>
			)}
			{categories && <Categories categories={categories} />}
			<H2 className="mb-4 lg:mb-6 mt-4">{title}</H2>
			{author && (
				<div className="mb-2">
					<Avatar author={author} />
				</div>
			)}
			<Muted className="mb-4 lg:mb-6 ">
				<Date dateString={date} />
			</Muted>
		</>
	);
}
